import { AdUnitForTable } from 'features/inventory/ad-unit/components/AdUnitsTable/types/model'
import { AdUnitProductsAttributes } from 'features/inventory/ad-unit/forms/AdUnitTableForm/schema'

export const adUnitToProductsAttributes = (adUnit: AdUnitForTable): AdUnitProductsAttributes => ({
  prebidStackEnabled: adUnit.prebidStackEnabled,
  priceGeniusEnabled: adUnit.priceGeniusEnabled,
  refresherEnabled: adUnit.refresherEnabled,
  unfilledRecoveryEnabled: adUnit.unfilledRecoveryEnabled,
  viewabilityToolsEnabled: adUnit.viewabilityToolsEnabled,
})
